import { render, staticRenderFns } from "./header-cabinet.vue?vue&type=template&id=4cfd5a38"
import script from "./header-cabinet.vue?vue&type=script&lang=js"
export * from "./header-cabinet.vue?vue&type=script&lang=js"
import style0 from "./header-cabinet.vue?vue&type=style&index=0&id=4cfd5a38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports